<template>
  <div class="container">
      <p class="title">Заказать товар</p>
    <a href="/shop/art-step">Фурнитура</a>
  </div>
</template>
<script>
export default {
  data: () => ({}),
};
</script>
<style lang="scss" scoped>
a {
  width: 100%;
  display: flex;
  font-weight: 500;
  font-size: 14px;
  color: #000;
  text-transform: uppercase;
  height: 45px;
  align-items: center;
  justify-content: center;
  background: #c4c4c4;
  margin-bottom: 15px;
}

.title{
    font-weight: bold;
    font-size: 24px;
    line-height: 35px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    text-align: center;
    padding-top: 35px;
    padding-bottom: 25px;
}
</style>